const fr = {
  nav: {
    howItWorks: "Fonctionnement",
    fees: "Frais",
    corridors: "Corridors",
    security: "Sécurité",
    press: "Presse",
    faq: "FAQ",
    contact: "Contact",
    joinWaitlist: "Liste d'attente",
    joinWaitlistLong: "Rejoindre la liste d'attente",
    openMenu: "Ouvrir le menu",
    language: "Langue",
  },
  hero: {
    eyebrow: "Embarquement · Liste d'attente ouverte",
    tag: "v1.0 — bêta privée sur corridors sélectionnés",
    line1: "Envoyez",
    line2: "vite.",
    line3: "Afrique \u2194 monde.",
    subhead:
      "Instantxfer CashApp transfère de l'argent entre l'Afrique et le reste du monde en quelques minutes — frais les plus bas, taux mid-market en direct, paiement vers banque, mobile money, retrait cash ou identifiant scan-to-pay.",
    ctaWaitlist: "Accès anticipé",
    ctaHow: "Voir un transfert en direct",
    trust: {
      settleLabel: "Règlement médian",
      feeLabel: "Frais totaux du transfert*",
      countriesLabel: "Pays au lancement",
      feeNote: "*taux mid-market, sans marge FX cachée",
      backedBy: "Soutenu par des partenaires de paiement régulés dans 34 marchés",
    },
  },
  liveQuote: {
    eyebrow: "Devis en direct",
    liveMid: "direct · mid-market",
    youSend: "Vous envoyez",
    receive: "Ils reçoivent",
    fee: "Frais",
    corridor: "Corridor",
    getRate: "Verrouiller ce taux",
  },
  corridors: {
    eyebrow: "Corridors disponibles",
    headline: "Taux de change compétitifs",
    headlineItalic: "sur chaque transfert.",
    intro:
      "Instantxfer CashApp est actuellement disponible dans ces pays.",
    introHighlight: " D'autres arrivent bientôt.",
    mostRequested: "Les plus demandés",
    active: "Actifs",
    comingSoon: "Bientôt disponibles",
    activePill: "Actif",
    soonPill: "Bientôt",
    votedPill: "Voté",
    tapToVote: "Touchez un pays « bientôt » pour voter",
    sentToday: "envoyés aujourd'hui",
    votes: "votes",
    notSeeing: "Vous ne trouvez pas votre corridor\u00A0?",
    requestIt: "Demandez-le",
    requestTail: " — les corridors les plus votés sont construits en premier.",
    footer: "Taux en direct · mid-market · 0,9\u00A0% forfaitaire",
    you: "Vous",
  },
  waitlist: {
    eyebrow: "Accès anticipé",
    title: "Réservez votre identifiant,",
    italic: "verrouillez vos frais à vie.",
    body: "Instantxfer CashApp se déploie corridor par corridor. Les membres du Cercle Fondateur bénéficient de 0,5\u00A0% à vie, de limites de paiement prioritaires et du premier choix des identifiants scan-to-pay.",
    formTitle: "Rejoindre la bêta privée",
    email: "E-mail",
    emailPlaceholder: "vous@entreprise.com",
    fullName: "Nom complet (facultatif)",
    fullNamePlaceholder: "Votre nom",
    corridor: "Votre corridor principal",
    submit: "Réserver ma place",
    submitting: "Réservation…",
    already: "Vous êtes déjà inscrit.",
    successTitle: "Vous êtes inscrit.",
    successBody: "Consultez votre boîte mail — nous venons d'envoyer une confirmation avec les taux mid-market du jour.",
    founderTitle: "Vous êtes fondateur.",
    founderBody: "Consultez votre boîte mail — un mot personnel du fondateur arrive, avec tous vos avantages à vie.",
    error: "Une erreur est survenue. Veuillez réessayer.",
    invalidEmail: "Veuillez saisir un e-mail valide.",
    privateBeta: "Bêta privée · Places limitées",
    skipQueue1: "Passez devant la file",
    skipQueue2Italic: "en deux champs.",
    membersLine: "Les premiers membres verrouillent les frais les plus bas à vie, des limites de paiement prioritaires et l'accès en avant-première à l'identifiant scan-to-pay. Aucune carte requise.",
    founderLive: "Fondateur 100 · en direct",
    seatsTaken: "pris",
    seatsFillLive: "Les places se remplissent en direct",
    seatsLeft: "restantes",
    referredBy: "Parrainé par",
    skipQueueTag: "· vous passez devant",
    quoteLabel: "Votre devis\u00A0:",
    quoteCta: "Réservez votre place pour l'envoyer pour de vrai — nous avons pré-sélectionné votre corridor.",
    nudgeTitle: "Vous ne savez pas par où commencer\u00A0? Essayez le calculateur d'envoi →",
    nudgeBody: "Voyez les taux en direct sur votre corridor, puis revenez réserver votre place.",
    inviteLink: "Votre lien d'invitation",
    bringFriend: "Invitez un ami · un passe-file offert",
    copy: "Copier",
    copied: "Copié",
    share: "Partager",
    inviteFootnote: "Toute personne qui rejoint via votre lien passe devant. Tant qu'il reste des places, elle devient aussi fondatrice.",
    openFounderCircle: "Ouvrir le Cercle Fondateur",
    agreeTerms: "En vous inscrivant, vous acceptez nos",
    and: "et notre",
    noSpam: ". Zéro spam, jamais.",
    terms: "conditions",
    privacy: "confidentialité",
  },
  footer: {
    ctaEyebrow: "Envoyez l'argent comme un message",
    ctaTitle: "L'Afrique et le monde,",
    ctaTitleItalic: "à deux gestes près.",
    ctaBtn: "Accès anticipé",
    colProduct: "Produit",
    colCompany: "Entreprise",
    colLegal: "Légal",
    colReach: "Contact",
    linkFounders: "Cercle Fondateur",
    linkAbout: "À propos",
    linkPress: "Presse",
    terms: "Conditions d'utilisation",
    privacy: "Confidentialité",
    amlKyc: "AML / KYC",
    cookies: "Cookies",
    systemsNominal: "Systèmes nominaux",
    rights: "Tous droits réservés.",
    chatWhatsApp: "Discuter avec nous sur WhatsApp",
  },
  contact: {
    whatsApp: "WhatsApp",
    whatsAppNote: "Les fondateurs répondent en moins d'une heure · 09h00–20h00 WAT",
    chatWhatsApp: "Discuter avec nous sur WhatsApp",
  },
  foundersVideo: {
    eyebrow: "Le fondateur en 30 secondes",
    title: "Un bonjour de trente secondes",
    italic: "signé Phil-Kholynes.",
    body: "Pourquoi nous construisons Instantxfer CashApp, à qui il s'adresse, et les corridors que nous allumons ensuite. Directement par le fondateur.",
    comingSoon: "Vidéo bientôt disponible",
    duration: "0:30",
    playAria: "Lancer la vidéo d'introduction du fondateur",
  },
  launchToast: {
    eyebrow: "Corridor · en direct",
    headline: "Vous l'avez demandé. {{country}} est en ligne.",
    body: "Taux mid-market, mobile money + rails bancaires — actifs dès aujourd'hui pour {{country}}.",
    cta: "Envoyer votre premier transfert",
    dismiss: "Fermer",
  },
  about: {
    seoTitle: "À propos · Quatre fondateurs, une mission — Instantxfer CashApp",
    seoDescription: "Rencontrez les quatre fondateurs qui construisent le WhatsApp de l'argent transfrontalier. Portraits, histoire, et les valeurs imprimées sur chaque reçu.",
    hero: {
      eyebrow: "Les fondateurs",
      title: "Quatre personnes,",
      italic: "un carnet de portraits.",
      body: "Nous avons créé Instantxfer CashApp parce qu'envoyer de l'argent au pays ne devrait pas donner l'impression de supplier une banque. Rencontrez l'équipe derrière le reçu.",
    },
    photobook: {
      eyebrow: "Portraits · Cercle Fondateur",
      title: "Les personnes qui ont signé",
      italic: "le manifeste.",
      body: "Chaque engagement du manifeste est signé par ces quatre. Aucun deck de conseil ne peut remplacer ça.",
      captionRole: "Rôle",
      captionCity: "Ville",
      captionSince: "Avec nous depuis",
      share: "Partager le portrait",
      shareCopied: "Lien copié",
    },
    timeline: {
      eyebrow: "Carnets de terrain · L'histoire fondatrice",
      title: "D'une idée",
      italic: "à mille expéditeurs.",
      body: "Pas un keynote. Un ensemble de reçus chronologiques, dans l'ordre où ils sont arrivés.",
      chapters: [
        {
          date: "Fév. 2024",
          tag: "L'idée",
          title: "Deux virements, un appel dominical.",
          body: "Phil-Kholynes envoie des frais de scolarité à Enugu un dimanche. Trois banques, quarante-sept minutes, 34\u00A0£ envolés. Le lendemain matin, un document Notion partagé intitulé « instantxfer.md » contient 14 points et une ligne de manifeste.",
        },
        {
          date: "Avr. 2024",
          tag: "Premier prototype",
          title: "Un calculateur qui disait la vérité.",
          body: "L'équipe livre un widget d'envoi statique qui affiche le taux mid-market — sans marge, sans surcoût de virement. C'est moche. C'est juste. C'est tout ce qui compte.",
        },
        {
          date: "Août 2024",
          tag: "Premier transfert",
          title: "100\u00A0£ → 168\u00A0900\u00A0₦, 42\u00A0secondes.",
          body: "Le premier transfert en direct arrive sur le compte GTBank de la mère d'Adaeze avant que sa tasse de thé n'ait fini d'infuser. Le reçu est imprimé sur le frigo. Il y est toujours.",
        },
        {
          date: "Nov. 2024",
          tag: "Les cent premiers",
          title: "Le Cercle Fondateur ouvre.",
          body: "Cent croyants s'inscrivent en neuf jours. Chacun reçoit un mot manuscrit et une place à 0,5\u00A0% à vie. Leurs noms restent sur le classement, pour toujours.",
        },
        {
          date: "Mars 2026",
          tag: "Le premier millier",
          title: "Des corridors ouverts sur quatre continents.",
          body: "Dix-sept corridors actifs. Taux mid-market en direct. Mobile money + banque + identifiant scan-to-pay. Mille expéditeurs, envoyant de l'argent comme un message. Le Canada rejoint la carte.",
        },
        {
          date: "Maintenant",
          tag: "Le déploiement public",
          title: "Vous, ensuite.",
          body: "Bêta privée ouverte, places du Fondateur 100 se remplissent vite. Tous les engagements du manifeste tiennent toujours. Les reçus continuent d'être imprimés.",
        },
      ],
    },
    manifestoNote: "Signé par les quatre, imprimé sur chaque reçu.",
  },
  rateAlert: {
    eyebrow: "Alertes de taux",
    headline: "Recevez une alerte quand",
    headlineItalic: "bouge de 1\u00A0%",
    headlineTail: "en votre faveur.",
    body: "Un e-mail, uniquement quand le taux est meilleur. Pas de spam, désinscription en un clic.",
    submit: "M'alerter quand ça bouge",
    sending: "Envoi…",
    successTitle: "C'est parti.",
    alreadyTitle: "Vous êtes déjà inscrit.",
    successBody: "Nous préviendrons {{email}} quand {{from}} → {{to}} bouge d'au moins 1\u00A0%.",
    errorRetry: "Veuillez réessayer.",
    errorNet: "Souci réseau. Réessayez dans un instant.",
  },
  rateLock: {
    eyebrow: "Taux verrouillé · 24h offertes",
    headline: "Verrouillez",
    headlineItalic: "le taux d'aujourd'hui",
    headlineTail: "pendant 24 heures.",
    body: "En prime d'inscription, nous honorons le taux mid-market d'aujourd'hui pour votre premier transfert — même si le marché se retourne. Un e-mail, un verrouillage, zéro frais cachés.",
    submit: "Verrouiller ce taux",
    submitting: "Verrouillage…",
    successTitle: "Taux verrouillé.",
    alreadyTitle: "Vous avez déjà verrouillé ce taux.",
    lockedAt: "Vous avez verrouillé",
    goodUntil: "Valide jusqu'au",
    finishSignup: "Finaliser mon inscription",
    errorRetry: "Veuillez réessayer.",
    errorNet: "Souci réseau. Réessayez dans un instant.",
    countdown: "Verrouillage expire dans",
    share: "Partager mon verrouillage",
    downloadCard: "Télécharger la carte",
    days: "j",
    hours: "h",
    minutes: "min",
    seconds: "s",
    leaderboard_one: "{{count}} taux verrouillé ces 24 dernières heures",
    leaderboard_other: "{{count}} taux verrouillés ces 24 dernières heures",
  },
  cookies: {
    heading: "Nous en utilisons",
    headingItalic: "quelques-uns.",
    body: "Nous utilisons quelques cookies pour vous reconnaître et améliorer le site. Ni publicité, ni suivi tiers.",
    acceptAll: "Tout accepter",
    onlyEssential: "Essentiels uniquement",
    privacy: "Politique de confidentialité",
  },
  common: {
    live: "Actif",
    soon: "Bientôt",
    watchCorridor: "Surveiller ce corridor",
    open: "Ouvrir le corridor",
    close: "Fermer",
  },
  home: {
    trust: { eyebrow: "Branché sur les rails", body: "Partenariats de paiement directs sur chaque corridor — sans banque correspondante au milieu." },
    send: { eyebrow: "Essayez avant d'installer", title: "Le chiffre exact,", italic: "avant de valider." },
    manifesto: { eyebrow: "Le manifeste", headline: "Six engagements, imprimés sur le reçu.", chaptersLabel: "Chapitres", tag: "Écrit à la main · signé par les quatre fondateurs", items: [
      { title: "Les frais tiennent sur une ligne.", body: "0,9\u00A0% forfaitaire. Aucune marge de virement. Aucune marge FX cachée. Ce que vous envoyez est ce qu'ils reçoivent — imprimé sur le ticket avant de valider." },
      { title: "Des minutes, pas des jours ouvrés.", body: "Rails directs vers le mobile money et les réseaux bancaires dans 34 pays. La plupart des transferts sont réglés en moins de trois minutes." },
      { title: "Un identifiant pour tout.", body: "@philKholynes.instant fonctionne partout. Banque, portefeuille, retrait cash — ou un QR EMVCo scanné à l'épicerie du coin à Kigali." },
      { title: "La famille d'abord, la finance ensuite.", body: "Soutien récurrent, partage entre frères et sœurs, paiement direct à l'école, recharge de crédit — pensé pour la vraie vie du transfert." },
      { title: "Régulé là où ça compte.", body: "Partenaires de paiement agréés des deux côtés. Un KYC qui respecte votre temps — trois champs, quatre-vingt-dix secondes, une photo." },
      { title: "Conçu pour le prochain milliard.", body: "Performances natives iOS, reçus hors-ligne, mode faible bande passante, et support en neuf langues dont le yoruba, le swahili et l'amharique." },
    ]},
    corridorMap: { eyebrow: "Corridors · 34 pays" },
    payout: { eyebrow: "Modes de paiement", title: "Livrez l'argent", italic: "comme la vie l'attend." },
    handle: { eyebrow: "Scan · Envoi · Règlement", title: "Un identifiant.", italic: "Partout." },
    leaderboard: { eyebrow: "Classement fondateurs", title: "Les cent premiers", italic: "qui ont cru en nous." },
    comparison: { eyebrow: "Le calcul", title: "Ce que vous économisez,", italic: "affiché en vert." },
    editorial: { eyebrow: "Carnets de terrain", title: "L'histoire du transfert,", italic: "telle qu'on la réécrit." },
    security: { eyebrow: "Sécurité & conformité", title: "Solide comme une banque,", italic: "conçu comme un message." },
    appStore: { eyebrow: "Arrive au 2\u1D49 trimestre 2026", title: "iOS & Android,", italic: "le même jour." },
    qrInstall: { eyebrow: "Scanner pour installer", title: "Pointez un téléphone.", italic: "Envoyez.", subtitle: "Scannez avec votre téléphone" },
  },
  pageHero: {
    howItWorks: {
      eyebrow: "Fonctionnement",
      title: "Envoyez de l'argent comme un SMS.",
      italic: "Arrive avant votre réponse.",
      body: "Quatre étapes, un geste. Instantxfer CashApp règle vos transferts transfrontaliers entre l'Afrique et le monde en quelques minutes — frais les plus bas, taux mid-market en direct, paiement vers banque, mobile money, retrait cash ou identifiant scan-to-pay.",
    },
    fees: {
      eyebrow: "Frais",
      title: "Un forfait unique de 0,9\u00A0%.",
      italic: "Sans marge FX cachée.",
      body: "Nous facturons un seul frais honnête — 0,9\u00A0% du transfert — en plus du taux mid-market réel. Les membres du Fondateur 100 verrouillent 0,5\u00A0% à vie.",
    },
    countries: {
      eyebrow: "Corridors",
      title: "17 corridors actifs.",
      italic: "40 autres arrivent bientôt.",
      body: "Instantxfer CashApp est actuellement disponible dans ces pays. Votez pour le corridor dont vous avez besoin — les plus demandés sont construits en premier.",
    },
    security: {
      eyebrow: "Sécurité",
      title: "Sécurité de niveau bancaire,",
      italic: "attention à taille humaine.",
      body: "Partenaires de paiement régulés dans 34 marchés. Chiffré de bout en bout. Authentification multifacteur par défaut. Votre argent est conservé sur des comptes séparés et cantonnés.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Tout ce qu'il faut savoir",
      italic: "pour nous confier votre argent.",
      body: "Réponses courtes aux questions les plus fréquentes des fondateurs, des expéditeurs et de la presse.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Dites-nous bonjour.",
      italic: "Réponse sous 24\u00A0h.",
      body: "Presse, partenariats, questions de la route. Contactez l'équipe fondatrice directement — pas de file de tickets, pas de bot.",
    },
    press: {
      eyebrow: "Presse · salle des signaux",
      title: "Tout ce dont un journaliste",
      italic: "a besoin en moins d'une minute.",
      body: "Biographies des fondateurs, éléments de marque, aperçus du digest hebdomadaire, ligne directe avec l'équipe.",
    },
    founders: {
      eyebrow: "Cercle Fondateur",
      title: "Les cent premiers",
      italic: "qui ont cru en nous.",
      body: "Les membres du Fondateur 100 bénéficient de 0,5\u00A0% à vie, de limites de paiement prioritaires et du premier choix des identifiants scan-to-pay.",
    },
    waitlist: {
      eyebrow: "Accès anticipé",
      title: "Réservez votre identifiant,",
      italic: "verrouillez vos frais à vie.",
      body: "Instantxfer CashApp se déploie corridor par corridor. Les membres du Cercle Fondateur bénéficient de 0,5\u00A0% à vie, de limites de paiement prioritaires et du premier choix des identifiants scan-to-pay.",
    },
    terms: { eyebrow: "Légal", title: "Conditions d'utilisation.", italic: "En clair, autant que possible.", body: "Les règles qui régissent votre utilisation d'Instantxfer CashApp." },
    privacy: { eyebrow: "Légal", title: "Politique de confidentialité.", italic: "Vos données, vos règles.", body: "Ce que nous collectons, pourquoi, et comment demander leur suppression." },
    aml: { eyebrow: "Conformité", title: "AML & KYC.", italic: "Comment nous gardons le réseau propre.", body: "Les vérifications d'identité, d'origine des fonds et de surveillance qui protègent la plateforme." },
    cookies: { eyebrow: "Légal", title: "Cookies.", italic: "Le strict minimum.", body: "Les cookies essentiels que nous utilisons et les statistiques qui nous aident à construire mieux." },
  },
  content: {
    howItWorks: {
      steps: [
        {
          title: "Vérifiez en 90 secondes",
          body: "Prenez votre pièce d'identité en photo, un selfie. Le moteur KYC d'Instantxfer CashApp confirme votre identité — souvent avant que votre bouilloire ne chauffe.",
          detail: ["Passeport, permis ou carte nationale", "Contrôle automatique de vivacité", "Coffre biométrique à divulgation nulle"],
        },
        {
          title: "Ajoutez vos proches",
          body: "Banque, portefeuille ou identifiant — choisissez la voie la plus rapide. Enregistrez une fois, réutilisez pour toujours avec Face-ID.",
          detail: ["M-Pesa · MoMo · Orange · Airtel", "Banque via routing / IBAN / GT#", "@identifiant.instant sur tous les réseaux"],
        },
        {
          title: "Envoyez avec le montant exact",
          body: "Voyez le taux mid-market, les frais et ce qu'ils recevront — au centime près — avant d'appuyer sur envoyer. Pas de marge, pas de surprise.",
          detail: ["Taux mid-market en direct", "0,9\u00A0% forfaitaire, divulgué d'avance", "Verrouillage optionnel pendant 24\u00A0heures"],
        },
        {
          title: "Voyez-le arriver",
          body: "Médiane sous trois minutes vers mobile money, banques ou retrait cash en agence. Vous recevez un reçu avec un lien partageable pour prévenir votre destinataire.",
          detail: ["Suivi du paiement en direct", "Confirmation SMS + push", "Support humain 24/7 en bêta"],
        },
      ],
    },
    fees: {
      note: "Les prix affichés sont illustratifs. Les tarifs du Cercle Fondateur s'appliquent la première année et nécessitent une inscription pendant la bêta privée.",
      tiers: [
        {
          name: "Particulier",
          priceNote: "forfaitaire, par envoi",
          features: ["Jusqu'à 10\u00A0000\u00A0$ / mois", "Banque + mobile money + QR", "Change mid-market en direct", "Support 24/7"],
          cta: "Rejoindre la liste",
        },
        {
          name: "Cercle Fondateur",
          priceNote: "la première année",
          features: ["Les 5\u00A0000 premiers uniquement", "Paiements prioritaires jusqu'à 50\u00A0k$ / mois", "Ligne directe avec les fondateurs", "Accès anticipé au scan-to-pay"],
          cta: "Réserver ma place",
        },
        {
          name: "Entreprise",
          priceNote: "tarification sur mesure",
          features: ["Remises sur volume dès 50\u00A0k$ / mois", "Rôles multi-utilisateurs + journal d'audit", "API + webhooks", "Chargé de compte dédié"],
          cta: "Contacter les ventes",
        },
      ],
    },
    security: {
      controls: [
        { title: "Coffre-fort, lié à l'appareil", body: "Les jetons de session sont liés à l'appareil physique via Secure Enclave / StrongBox. Chaque paiement est signé sur l'appareil avant de partir." },
        { title: "Synchronisation à divulgation nulle", body: "Vos contacts et votre historique de transferts sont chiffrés avec des clés que nous ne pouvons pas lire. Si notre base fuitait, un attaquant ne trouverait que du bruit." },
        { title: "Moteur anti-fraude 3D", body: "Chaque envoi est noté selon des signaux d'appareil, de comportement et de réseau. Les anomalies mettent l'envoi en pause et déclenchent une revue humaine — en quelques secondes." },
        { title: "Piste d'audit sur chaque rail", body: "Journaux immuables et signés chez tous les partenaires de paiement. La réconciliation tourne en continu — pas une fois par jour à 4h du matin." },
        { title: "Régulé, pas rebelle", body: "Instantxfer CashApp s'associe à des établissements de services de paiement agréés dans chaque corridor. Les fonds sont cantonnés dans des comptes séparés de banques de premier rang." },
        { title: "Divulgation coordonnée", body: "Divulgation coordonnée avec une prime permanente. Chercheurs en sécurité bienvenus — security@instantxfer.com." },
      ],
    },
    faq: {
      items: [
        { q: "À quelle vitesse un transfert arrive-t-il, vraiment\u00A0?", a: "Le règlement médian est sous trois minutes vers le mobile money et les grandes banques au Nigeria, Kenya, Ghana, Ouganda, Rwanda, Sénégal, Côte d'Ivoire et Afrique du Sud. Les virements vers de plus petites institutions peuvent prendre jusqu'à 30\u00A0minutes selon les fenêtres du réseau destinataire." },
        { q: "Combien coûte réellement Instantxfer CashApp\u00A0?", a: "0,9\u00A0% du montant envoyé, calculé au taux mid-market. Pas de marge, pas de frais de virement, pas d'abonnement. Les corridors de retrait cash impliquent un petit frais d'agent (1–3\u00A0$) que nous affichons d'avance." },
        { q: "Quels réseaux de mobile money supportez-vous\u00A0?", a: "M-Pesa (Kenya, Tanzanie), MTN MoMo (Ghana, Nigeria, Ouganda, Rwanda, Zambie, Côte d'Ivoire, Bénin), Orange Money (Sénégal, Côte d'Ivoire, Mali), Airtel Money (Ouganda, Zambie, Malawi), Wave (Sénégal, Côte d'Ivoire), Telebirr (Éthiopie), et plusieurs portefeuilles régionaux." },
        { q: "C'est quoi cet identifiant scan-to-pay\u00A0?", a: "Votre identifiant Instantxfer CashApp (@votrenom.instant) est une identité de paiement portable. Imprimez-le, partagez-le dans une conversation ou scannez le QR EMVCo d'un commerçant — l'argent est réglé instantanément, sans carte ni numéro de compte." },
        { q: "Comment gagnez-vous de l'argent avec des frais aussi bas\u00A0?", a: "Nous réglons en gros sur des rails directs et prenons une petite marge sur le flux — jamais sur le taux de change. À mesure que nous grandissons, l'économie s'améliore, et nous le rendons aux membres du Cercle Fondateur." },
        { q: "Mon argent est-il en sécurité\u00A0?", a: "Les fonds sont cantonnés dans des comptes séparés de banques de premier rang. Instantxfer CashApp s'associe à des établissements de services de paiement agréés dans chaque corridor. Les soldes sont couverts jusqu'à la limite réglementaire applicable dans votre juridiction." },
        { q: "Quels documents pour le KYC\u00A0?", a: "Une photo de votre passeport, carte nationale ou permis, plus un selfie rapide. La vérification prend typiquement moins de 90 secondes. Les comptes professionnels nécessitent des documents corporatifs et la divulgation des bénéficiaires effectifs." },
        { q: "Supportez-vous la crypto\u00A0?", a: "Pas au lancement. Nous pourrions ajouter des rails stablecoin optionnels pour le règlement inter-corridor — mais le produit grand public reste fiat, mobile money et virement bancaire." },
        { q: "Quand Instantxfer CashApp est-il lancé\u00A0?", a: "La bêta privée est envoyée d'abord aux membres du Cercle Fondateur. Le déploiement public suit sur des corridors sélectionnés — rejoignez la liste d'attente pour recevoir votre invitation." },
      ],
    },
  },
};

export default fr;
